import { formatCurrency, getUSNumberFormat } from 'helpers/formatData';

export const disbursementColumns = [
  {
    Header: 'Property Name',
    accessor: 'name',
    align: 'left',
    disableSortBy: true,
  },
  {
    Header: 'Rent of the property',
    accessor: 'rent',
    align: 'right',
    disableSortBy: true,
  },
  {
    Header: 'Management Fee',
    accessor: 'fee',
    align: 'right',
    disableSortBy: true,
  },
  {
    Header: 'Loan Payment',
    accessor: 'loan',
    align: 'right',
    disableSortBy: true,
  },
  {
    Header: 'Insurance',
    accessor: 'insurance',
    align: 'right',
    disableSortBy: true,
  },
  { Header: 'Tax', accessor: 'tax', align: 'right', disableSortBy: true },
  {
    Header: 'Rent to Disburse',
    accessor: 'disburse',
    align: 'right',
    disableSortBy: true,
  },
  {
    Header: 'Total no of investors',
    accessor: 'investors',
    align: 'right',
    disableSortBy: true,
  },
  {
    Header: 'Source account',
    accessor: 'sourceId',
    align: 'right',
    disableSortBy: true,
  },
];

export const disbursementRows = (list) => {
  return list?.propertyDividend?.map((rowData) => {
    const {
      propertyName,
      rentOfTheProperty,
      managementFees,
      loanPayment,
      insurance,
      tax,
      restToDisburse,
      totalNoOfInvestors,
      sourceAccountId,
    } = rowData;
    return {
      name: propertyName,
      rent: formatCurrency(rentOfTheProperty),
      fee: formatCurrency(managementFees),
      loan: formatCurrency(loanPayment),
      insurance: formatCurrency(insurance),
      tax: formatCurrency(tax),
      disburse: formatCurrency(restToDisburse),
      investors: getUSNumberFormat(totalNoOfInvestors),
      sourceId: 'xxxx'+sourceAccountId,
    };
  });
};
